import TrashIcon from 'assets/icons/trash.svg';
import { InputField, MyCheckbox } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import { fontConfig } from "theme/fontConfig";
const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
const ttlStyle = { fontFamily: fontConfig.FormsTtlFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 };
const inputTitleStyle = { fontFamily: fontConfig.FormsInputTitleFont.family, fontWeight: '400', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F' };
const TLabel = ({ text, mandatory }) => (
  <label style={ttlStyle}>{text}{mandatory && <span style={{ color: 'red' }}> *</span>}</label>
);
const OptionalTypesItems = ({ formik, index, variantIndex, removeVariantHandler, acceptNumbersAndGtZero }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  // const type= formik.values?.prices?.[index]?.type;
  const variants =
  formik.values?.prices?.[index]?.variantInfo || [];

const isAnotherOpenAmountSelected = variants.some(
  (v, i) =>
    v?.openAmount && i !== variantIndex
);
  return (
   <>
   {formik.values?.prices?.[index]?.type === "Addons" && (
  <>
    {/* Row 1: Variant | Member Only */}
    <Row style={{ marginBottom: "8px", position: "relative" }}>
      <Col className="col-sm-6">
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
          <TLabel text="Variant" mandatory />
          <InfoTooltip text="A name to identify this price tier." />
        </div>
        <InputField
          titleStyle={inputTitleStyle}
          title="none"
          formik={formik}
          name={`prices[${index}].variantInfo[${variantIndex}].name`}
          placeholder="Variant Name"
          maxLength={50}
          value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name || ""}
          mandatory={true}
          handleChange={(e) =>
            formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].name`, e.target.value)
          }
          checkValidation={true}
          onBlur={formik.handleBlur}
        />
      </Col>
      <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
        {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
            <MyCheckbox
              title="Member Only"
              checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly || false}
              handlechange={(e) =>
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
              }
            />
            <InfoTooltip text="Restrict this add-on variant to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
          </div>
        )}
      </Col>
      <div
        className="optional_type-remove-icon"
        onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
        style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
      >
        <img src={TrashIcon} alt="" />
      </div>
    </Row>
    {/* Row 2: Quantity | No Limit */}
    <Row style={{ marginBottom: "8px" }}>
      <Col className="col-sm-6">
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
          <TLabel text="Quantity" mandatory />
          <InfoTooltip text="Number of this add-on available. E.g., 30 parking passes, 50 meal tickets." />
        </div>
        <InputField
          titleStyle={inputTitleStyle}
          title="none"
          formik={formik}
          name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
          placeholder="Quantity"
          value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity || ""}
          mandatory={!formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
          handleChange={(e) => {
            let value = acceptNumbersAndGtZero(e.target.value);
            if (parseInt(value) > 10000) value = 10000;
            formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, value);
          }}
          disabled={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
          max={10000}
          checkValidation={!formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
          onBlur={formik.handleBlur}
        />
      </Col>
      <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <MyCheckbox
            title="No Limit"
            checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity || false}
            disabled={formik.values?.prices?.[index]?.required === true}
            handlechange={(e) => {
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`, e.target.checked);
              if (e.target.checked) {
                formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].quantity`, '');
                formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false, false);
              }
            }}
          />
          <InfoTooltip text="Check to remove the quantity cap, allowing unlimited selections." />
        </div>
      </Col>
    </Row>
    {/* Row 3: Amount | Open Amount */}
    <Row style={{ marginBottom: "8px" }}>
      <Col className="col-sm-6">
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
          <TLabel text={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Amount"} mandatory />
          <InfoTooltip text="The price attendees pay for this add-on variant." />
        </div>
        <InputField
          titleStyle={inputTitleStyle}
          title="none"
          formik={formik}
          name={`prices[${index}].variantInfo[${variantIndex}].amount`}
          placeholder={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Amount"}
          mandatory={true}
          value={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount || ""}
          handleChange={(e) => {
            let value = e.target.value.match(regex)?.[0] || "";
            if (parseFloat(value) > 1000000) value = "1000000";
            formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].amount`, value);
          }}
          max={1000000}
          checkValidation={true}
          onBlur={formik.handleBlur}
        />
      </Col>
      <Col className="col-sm-6" style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
          <MyCheckbox
            title="Open Amount"
            checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount || false}
            disabled={!formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount && isAnotherOpenAmountSelected}
            handlechange={(e) =>
              formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].openAmount`, e.target.checked)
            }
          />
          <InfoTooltip text="Allow registrants to enter their own amount. The amount field becomes a minimum." style={{ marginBottom: '8px' }} />
        </div>
      </Col>
    </Row>
    {variantIndex !== variants.length - 1 && (
      <hr className="w-100 mb-5" style={{ borderBottom: "dashed 1px #002E5C", opacity: "0.2" }} />
    )}
  </>
)}
   {formik.values?.prices?.[index]?.type === "Optional" && (
  <>
    {/* Variant Row */}
    <Row style={{ marginBottom: "8px", position: "relative" }}>
  <Col className="col-sm-6">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
      <TLabel text="Variant" mandatory />
      <InfoTooltip text="A label to identify this tier." />
    </div>
    <InputField
      titleStyle={inputTitleStyle}
      title="none"
      formik={formik}
      name={`prices[${index}].variantInfo[${variantIndex}].name`}
      placeholder="Variant Name"
      maxLength={50}
      value={
        formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name || ""
      }
        mandatory={true}
      handleChange={(e) =>
        formik.setFieldValue(
          `prices[${index}].variantInfo[${variantIndex}].name`,
          e.target.value
        )
      }
      checkValidation={true}
      onBlur={formik.handleBlur}
    />
  </Col>

  <Col className="col-sm-6 d-flex align-items-center">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <MyCheckbox
        title="Member Only"
        checked={
          formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly || false
        }
        handlechange={(e) =>
          formik.setFieldValue(
            `prices[${index}].variantInfo[${variantIndex}].forMemberOnly`,
            e.target.checked
          )
        }
      />
      <InfoTooltip text="Restrict this option to members only.Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
    </div>
  </Col>

  <div
    className="optional_type-remove-icon"
    onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
    style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
  >
    <img src={TrashIcon} alt="" />
  </div>
</Row>

{/* Quantity Row */}
<Row style={{ marginBottom: "8px" }}>
  <Col className="col-sm-6">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
      <TLabel text="Quantity" mandatory />
      <InfoTooltip text="Number of times this option can be selected." />
    </div>
    <InputField
      titleStyle={inputTitleStyle}
      title="none"
      formik={formik}
      name={`prices[${index}].variantInfo[${variantIndex}].quantity`}
      placeholder="Quantity"
      value={
        formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity || ""
      }
        mandatory={
          !formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity &&
          formik.values?.prices?.[index]?.limitType !== 'checkbox'
        }
      handleChange={(e) => {
        let value = acceptNumbersAndGtZero(e.target.value);
        if (parseInt(value) > 10000) value = 10000;
        formik.setFieldValue(
          `prices[${index}].variantInfo[${variantIndex}].quantity`,
          value
        );
      }}
      disabled={
        formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity
      }
      max={10000}
      checkValidation={!formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
      onBlur={formik.handleBlur}
    />
  </Col>

  <Col className="col-sm-6 d-flex align-items-center">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <MyCheckbox
        title="No Limit"
        checked={
          formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity || false
        }
        handlechange={(e) =>{
          formik.setFieldValue(
            `prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`,
            e.target.checked
          )
          if (e.target.checked) {
            formik.setFieldValue(
              `prices[${index}].variantInfo[${variantIndex}].quantity`,
              ''
            );
            formik.setFieldTouched(`prices[${index}].variantInfo[${variantIndex}].quantity`, false, false);
          }
        }}
        disabled={formik.values?.prices?.[index]?.limitType === 'checkbox' || formik.values?.prices?.[index]?.required === true}
      />
      <InfoTooltip text="Check to remove the quantity cap, allowing unlimited selections." />
    </div>
  </Col>
</Row>

{/* Price Row */}
<Row style={{ marginBottom: "20px" }}>
  <Col className="col-sm-6">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
      <TLabel text={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Price"} mandatory />
      <InfoTooltip text="The price for this variant. If open amount is enabled, this will become minimum amount." />
    </div>
    <InputField
      titleStyle={inputTitleStyle}
      title="none"
      formik={formik}
      name={`prices[${index}].variantInfo[${variantIndex}].amount`}
      placeholder={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount ? "Min. Amount" : "Price"}
      value={
        formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount || ""
      }
        mandatory={true}
      handleChange={(e) => {
        let value = e.target.value.match(regex)?.[0] || "";
        if (parseFloat(value) > 1000000) value = "1000000";
        formik.setFieldValue(
          `prices[${index}].variantInfo[${variantIndex}].amount`,
          value
        );
      }}
      max={1000000}
         checkValidation={true}
      onBlur={formik.handleBlur}
    />
  </Col>

  <Col className="col-sm-6 d-flex align-items-center">
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <MyCheckbox
        title="Open Amount"
        checked={
          formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount || false
        }
         disabled={
          !formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.openAmount &&
          isAnotherOpenAmountSelected
        }
        handlechange={(e) =>
          formik.setFieldValue(
            `prices[${index}].variantInfo[${variantIndex}].openAmount`,
            e.target.checked
          )
        }
      />
      <InfoTooltip text="Allow registrants to enter their own amount. The price field becomes a minimum amount." style={{ marginBottom: '8px' }} />
    </div>
  </Col>
</Row>
{variantIndex !== variants.length - 1 && (
 <hr
                className="w-100 mb-5"
                style={{ borderBottom: "dashed 1px #002E5C", opacity: "0.2" }}
              />
)}
    {/* <Row style={{ marginBottom: "20px",    position: "relative" }}>
      <Col className="col-sm-6">
        <InputField
          title="Variant"
          formik={formik}
          name={`prices[${index}].variantName`}
          placeholder="Variant Name"
          value={formik.values?.prices?.[index]?.variantName || ""}
          handleChange={(e) =>
            formik.setFieldValue(
              `prices[${index}].variantName`,
              e.target.value
            )
          }
        />
      </Col>

      <Col className="col-sm-6 d-flex align-items-end">
        <MyCheckbox
          title="Member Only"
          checked={
            formik.values?.prices?.[index]?.forMemberOnly || false
          }
          handlechange={(e) =>
            formik.setFieldValue(
              `prices[${index}].forMemberOnly`,
              e.target.checked
            )
          }
        />
      </Col>
        <div
          className="optional_type-remove-icon"
          onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
          style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
        >
          <img src={TrashIcon} alt="" />
        </div>
    </Row>

    {/* Quantity Row
    <Row style={{ marginBottom: "20px" }}>
      <Col className="col-sm-6">
        <InputField
          title="Quantity"
          formik={formik}
          name={`prices[${index}].quantity`}
          placeholder="Quantity"
          value={formik.values?.prices?.[index]?.quantity || ""}
          handleChange={(e) =>
            formik.setFieldValue(
              `prices[${index}].quantity`,
              acceptNumbersAndGtZero(e.target.value)
            )
          }
          disabled={
            formik.values?.prices?.[index]?.infiniteQuantity
          }
        />
      </Col>

      <Col className="col-sm-6 d-flex align-items-end">
        <MyCheckbox
          title="No Limit"
          checked={
            formik.values?.prices?.[index]?.infiniteQuantity || false
          }
          handlechange={(e) =>
            formik.setFieldValue(
              `prices[${index}].infiniteQuantity`,
              e.target.checked
            )
          }
        />
      </Col>
    </Row>

    {/* Price Row 
    <Row style={{ marginBottom: "20px" }}>
      <Col className="col-sm-6">
        <InputField
          title="Price"
          formik={formik}
          name={`prices[${index}].amount`}
          placeholder="Price"
          value={formik.values?.prices?.[index]?.amount || ""}
          handleChange={(e) =>
            formik.setFieldValue(
              `prices[${index}].amount`,
              e.target.value.match(regex)[0]
            )
          }
          disabled={
            formik.values?.prices?.[index]?.openAmount
          }
        />
      </Col>

      <Col className="col-sm-6 d-flex align-items-end">
        <MyCheckbox
          title="Open Amount"
          checked={
            formik.values?.prices?.[index]?.openAmount || false
          }
          handlechange={(e) =>
            formik.setFieldValue(
              `prices[${index}].openAmount`,
              e.target.checked
            )
          }
        />
      </Col>
    </Row> */}
  </>
)}
   { formik.values?.prices?.[index]?.type === "On Registration" &&( <>
    
      <Row style={{
        marginBottom: '0px',
        position: 'relative'
      }}>
        <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <TLabel text="Variant" mandatory />
            <InfoTooltip text="A name to identify this price tier." />
          </div>
          <InputField
            titleStyle={inputTitleStyle}
            style={{  color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].name`}
            placeholder="Variant"
            checkValidation={true}
            maxLength={50}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.name
            }
            handleChange={(e) =>
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].name`,
                e?.target?.value
              )
            }
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
             onBlur={formik.handleBlur}
          />
          {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
            <div style={{ marginTop: '8px', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
              <MyCheckbox
                title="Members only"
                name="forMemberOnly"
                handlechange={(e) =>
                  formik.setFieldValue(`prices[${index}].variantInfo[${variantIndex}].forMemberOnly`, e.target.checked)
                }
                checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly}
              />
              <InfoTooltip text="Restrict this variant to members only. Require users to log in before accessing this variant." style={{ marginBottom: '8px' }} />
            </div>
          )}
        </Col>
       {formik.values?.prices?.[index]?.type === "Optional" && ( <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            style={{  color: '#002E5C' }}
            mandatory={formik.values?.prices?.[index]?.limitType !== 'checkbox'}
            formik={formik}
            title="Quantity"
            name="quantity"
            placeholder="Quantity"
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.quantity
            }
            handleChange={(e) => {
              let value = acceptNumbersAndGtZero(e?.target?.value.match(regex)[0]);
              if (parseInt(value) > 10000) value = 10000;
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].quantity`,
                value
              )
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            disabled={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity ||
              formik.values?.prices?.[index]?.limitType === 'checkbox'
            }
            max={10000}
          />
        </Col>)}
        {formik.values?.prices?.[index]?.type === "On Registration" && (  <Col className="col-sm-6">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
            <TLabel text="Amount" mandatory />
            <InfoTooltip text="The price attendees pay for this tier." />
          </div>
          <InputField
            titleStyle={inputTitleStyle}
            style={{  color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title="none"
            name={`prices[${index}].variantInfo[${variantIndex}].amount`}
            placeholder={"Amount"}
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount
            }
            handleChange={(e) => {
              const { value } = e.target;
              const minimumValue = 0;
              let updatedValue = value.match(regex)[0] >= minimumValue ? value.match(regex)[0] : '';
              if (parseFloat(updatedValue) > 1000000) updatedValue = "1000000";
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].amount`,
                updatedValue
              )
            }
            }
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            max={1000000}
             onBlur={formik.handleBlur}
          />
        </Col>)}
        <div
          className="optional_type-remove-icon"
          onClick={() => variants.length > 1 && removeVariantHandler(index, variantIndex)}
          style={{ opacity: variants.length <= 1 ? 0.3 : 1, cursor: variants.length <= 1 ? 'not-allowed' : 'pointer' }}
        >
          <img src={TrashIcon} alt="" />
        </div>
      </Row>
      <Row style={{
        marginBottom: '20px',
        justifyContent: 'center'
      }}>
     {formik.values?.prices?.[index]?.type === "Optional" && (  
      <>
       <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            style={{  color: '#002E5C' }}
            mandatory={true}
            formik={formik}
            title={"Price"}
            name="amount"
            placeholder={"Price"}
            checkValidation={true}
            value={
              formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.amount
            }

            handleChange={(e) => {
              const { value } = e.target;
              const minimumValue = 0;
              let updatedValue = value.match(regex)[0] >= minimumValue ? value.match(regex)[0] : '';
              if (parseFloat(updatedValue) > 1000000) updatedValue = "1000000";
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].amount`,
                updatedValue
              )
            }
            }
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            max={1000000}
          />
        </Col>
        <Col className="col-sm-6 d-flex align-items-end"
          style={{
            marginBottom: '-0.5rem',
            gap: '15px'
          }}
        >
          <MyCheckbox
            title="No Limit"
            name="infiniteQuantity"
            handlechange={(e) => {
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].infiniteQuantity`,
                e.target.checked
              );
              if (e.target.checked) {
                formik.setFieldValue(
                  `prices[${index}].variantInfo[${variantIndex}].quantity`,
                  ''
                );
              }
            }}
            checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.infiniteQuantity}
            disabled={
              (formik.values?.prices?.[index]?.type === 'Tickets' && !formik?.values?.eventDetails?.infiniteCapacity) ||
              formik.values?.prices?.[index]?.limitType === 'checkbox'
            }
          />
          {(orgDetails?.memberPortal && formik?.values?.allowNonMembers) && (
            <MyCheckbox
            title="Members only"
            name="forMemberOnly"
            handlechange={(e) => {
              formik.setFieldValue(
                `prices[${index}].variantInfo[${variantIndex}].forMemberOnly`,
                e.target.checked
              );
            }}
            checked={formik.values?.prices?.[index]?.variantInfo?.[variantIndex]?.forMemberOnly}
            />
          )}
        </Col></>)}
      </Row>
      {variantIndex !== variants.length - 1 && (
 <hr
                className="w-100 mb-5"
                style={{ borderBottom: "dashed 1px #002E5C", opacity: "0.2" }}
              />
)}
    </>)}</>
  )
}

export default OptionalTypesItems